import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import { useApiToken } from './useApiToken';

const KEY = ['settings'] as const;

export interface UserSettings {
  workingHoursStart: string;
  workingHoursEnd: string;
  wfhDays: number[];
  morningSummaryEnabled: boolean;
  morningSummaryTime: string;
  eveningRecapEnabled: boolean;
  eveningRecapTime: string;
  gcalSyncEnabled: boolean;
  gcalDefaultPrivacy: 'public' | 'private';
  timeFormat: '12h' | '24h';
  showSeconds: boolean;
  timezone: string;
  /** When true, completing a task with a running timer pops a confirm
   *  dialog asking whether to stop the timer too. Default false. */
  confirmStopOnComplete: boolean;
}

export function useSettings() {
  const { data: tokenData, isSuccess: tokenReady } = useApiToken();
  return useQuery({
    queryKey: KEY,
    queryFn: () => apiFetch<UserSettings>('/settings', { token: tokenData?.token }),
    enabled: tokenReady,
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  const { data: tokenData } = useApiToken();
  return useMutation({
    mutationFn: (patch: Partial<UserSettings>) =>
      apiFetch<UserSettings>('/settings', {
        method: 'PATCH',
        body: patch,
        token: tokenData?.token,
      }),
    onSuccess: (data) => qc.setQueryData(KEY, data),
  });
}
